import React from 'react';
import ReactDOM from 'react-dom/client';

import FileState from 'filestate/FileState';
import {isFileStateWithModel} from 'filestate/FileStateTypedefs';
import {getSubworkspaceHeaderMetadata} from 'nav/workspace/header/SubworkspaceHeaderUtil';
import {renderToDOM, unmountRootsAsync} from 'redux-stores/ReduxDOMRender';

export class SubworkspaceHeaderView extends Backbone.View<Backbone.Model> {
  file: FileState | null = null;
  reactRoot: ReactDOM.Root | null = null;

  static initClass(): void {
    this.prototype.el = '#subworkspaceHeader';
  }

  registerListeners(): void {
    if (this.file != null) {
      this.listenTo(this.file, 'change', this.render.bind(this));
      if (isFileStateWithModel(this.file)) {
        this.listenTo(this.file.model(), 'change', this.render.bind(this));
      }
    }
  }

  removeListeners(): void {
    if (this.file != null) {
      this.stopListening(this.file);
      if (isFileStateWithModel(this.file)) {
        this.stopListening(this.file.model());
      }
    }
  }

  update(fileState: FileState | null): void {
    if (this.file !== fileState) {
      this.removeListeners();
      this.file = fileState;
      this.registerListeners();
    }
    this.render();
  }

  override render(): this {
    // If we're looking at a file (vs empty workspace)...
    if (this.file != null) {
      const maybeMetadata = getSubworkspaceHeaderMetadata(this.file);
      // ...and the file has a header registered...
      if (maybeMetadata) {
        const {HeaderComponent, propsFromFileState, suppress} = maybeMetadata;
        // ...and the display is actually enabled...
        if (!suppress) {
          // ...then render the fancy header.
          this.reactRoot = renderToDOM(
            <HeaderComponent {...propsFromFileState(this.file)} />,
            this.el,
            this.reactRoot
          );
          return this;
        }
      }
    }
    // Otherwise render empty fragment so we always have a root and can always safely clean up.
    this.reactRoot = renderToDOM(<></>, this.el, this.reactRoot);
    return this;
  }

  override remove(): this {
    this.removeListeners();
    unmountRootsAsync([this.reactRoot], () => {
      super.remove();
    });
    return this;
  }
}
SubworkspaceHeaderView.initClass();
